import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import { Jumbotron, Grid, Row, Col, Image, Button } from 'react-bootstrap';
import './Home.css';

export default class Home extends Component {
  componentDidMount() {
    document.title = 'Chris DiNome';
  }

  render() {
    return (
      <Grid>
        <Jumbotron>
          <h1>About Me</h1>

          <div className="about-me">
            <p>
              Hello! My name is Chris DiNome. I am a full stack web developer currently working in Boston at
              PowerAdvocate. On this site you can find my personal projects and games, or take a look at my resume!
            </p>
          </div>

          <Link to="/projects">
            <AwesomeButton type="primary">Check out My Projects</AwesomeButton>
          </Link>

          <Link to="/resume">
            <AwesomeButton href="">My Resume</AwesomeButton>
          </Link>
        </Jumbotron>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.jsx